import { PosBookmarkListPage } from '@/features/pos-bookmark/pages/PosBookmarkListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pos-bookmark/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pos_bookmark.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PosBookmarkListPage,
})
